import { E_Language } from "@green24/npm-javascript-utils";

/**
 * Configuration display mode enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Configuration_DisplayMode = {
	DEFAULT: "DEFAULT",
	DELIVERY: "DELIVERY",
}

/**
 * Configuration model
 * ---
 * @type {{
 *  defaultLanguage: E_Language,
 *  apiURL: string,
 *  updateWaitTime: number|string,
 *  locationID: number,
 *  unitID: number,
 *  redirectTimeout: number|string,
 *  devApiURL: string,
 *  frontendID: string,
 *  mode: E_Configuration_DisplayMode|null
 * }}
 */
export const M_Configuration = {
	apiURL: undefined,
	devApiURL: undefined,
	defaultLanguage: "cs",
	redirectTimeout: "1m",
	updateWaitTime: "10m",
	locationID: undefined,
	unitID: undefined,
	frontendID: "",
	mode: null,
	allowDelivery: false,
	allowDeliveryUserSelection: false,
	allowDeliveryManualUserEntry: false,
}

export const DEFAULT_CONFIGURATION = {
	...M_Configuration,
	apiURL: `http://172.16.1.5:12250/box`,
	devApiURL: `http://172.16.1.5:12250/box`,
	defaultLanguage: "cs",
	redirectTimeout: "1m",
	debuggerDuration: "30m",
	updateWaitTime: "10m",
	locationID: 6,
	unitID: 11,
	mode: null,
	allowDelivery: false,
	allowDeliveryUserSelection: false,
	allowDeliveryManualUserEntry: false,
};
